import React, {Component} from 'react';

export default class BillingItems extends Component {

	state = {
		data : []
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data : nextProps.items
		});
		
	}

	componentWillMount() {
		this.setState({
			data : this.props.items
		})
	}

	handleClickRow = (e) => {
		let data = this.state.data;

		// eslint-disable-next-line
		if(data.billing.is_voided == 0 || typeof data.billing.is_voided === 'undefined') // is not voided
		{
			this.props.onclick(this.state.data);	
		}
		
	}

	handlePrint = (e) => {
		let bill = this.state.data;
		this.props.onPrint(e,bill)
	}

	render() {

		let list = this.state.data;
		
		return(
			// eslint-disable-next-line
			<tr onClick={this.handleClickRow} data-id={list.billing.id} style={list.billing.is_voided == 1 ? {color: 'red'} : {cursor: 'pointer'}}>
				{list.indexKey === 0 ? <td rowSpan={list.count} style={{verticalAlign: 'middle'}} >{list.dateKey}</td> : null}
				<td>{list.treatments.facility ? list.treatments.facility.name : ''}</td>
				<td>{list.treatments.procedures.map((procedure, k) => {
						return procedure.procedure + ', ';
					})}
				</td>
				<td>{parseFloat(Math.round(list.treatments.price * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
				<td>{'x ' + list.treatments.quantity}</td>
				{list.indexKey === 0 ? <td rowSpan={list.count} style={this.props.realBalance < 0 ? {verticalAlign: 'middle',color : '#00A651', fontWeight : 'bold'} : {verticalAlign: 'middle'}} >{parseFloat(this.props.amount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td> : null}
				{list.indexKey === 0 ? <td rowSpan={list.count} style={{verticalAlign: 'middle'}} >{parseFloat(this.props.balance).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td> : null}
			</tr>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Treatment_record/BillingItems.js
 **/